import { FormattedMessage } from '@flipster/i18n';
import { css } from '@flipster/styled-system/css';

export const EstAprTooltipContent = () => {
  return (
    <ul className={css({ list: 'disc', textStyle: 'Text/M/Regular' })}>
      <li>
        <FormattedMessage id='Earn.r251204.Apr_calculation_desc' />
      </li>
      <li>
        <FormattedMessage id='Earn.r260304.Est_apr_tooltip_description_2' />
      </li>
      <li>
        <FormattedMessage id='Earn.r260304.Est_apr_tooltip_description_3' />
      </li>
    </ul>
  );
};
